<template>
  <v-dialog v-model="open" scrollable persistent max-width="600px">
    <v-card>
      <v-card-title class="c-dialog-title">
        <select-community-header
          ref="cid"
          v-model="cid"
          :title="isEdit ? $T('page.member.info.group.edit.title') : $T('page.member.info.group.create.title')"
          :fixCommunity="isEdit"
          :icon="isEdit ? 'mdi-account-multiple' : 'mdi-account-multiple-plus'"
        ></select-community-header>
      </v-card-title>

      <v-divider></v-divider>

      <v-container grid-list-lg text-xs-left>
        <v-layout column wrap>
          <v-flex>
            <select-groups-members
              v-model="members"
              :communityId="cid"
              :allowAllCommunity="false"
              :includeGroups="false"
              :excludeSelf="false"
              :allAdmin="true"
              :allMember="true"
              memberSubContent="role"
              ref="members"
              :label="$T('attributes.group_member')"
              :max="100"
              :minH="50"
              :small="leTbS"
              :autofocus="!leTbS && !isEdit"
              :disabled="!cid || inputDisabled || loading"
              fieldName="members"
            />
          </v-flex>
          <v-flex v-show="editorRequired" class="c-editor">
            <select-groups-members
              v-model="editors"
              :communityId="cid"
              :allAdmin="true"
              :allowAllCommunity="false"
              :includeGroups="false"
              :excludeSelf="false"
              :onlyAdmin="true"
              :hint="$T('page.member.info.group.register.included')"
              memberSubContent="role"
              ref="editors"
              :label="$T('attributes.editors')"
              :max="10"
              :small="true"
              :autofocus="!leTbS && !isEdit"
              :disabled="!cid || inputDisabled || loading"
              fieldName="editors"
            />
          </v-flex>
          <v-flex>
            <div class="c-flex c-cover-area">
              <single-crop v-model="coverUpdated" :defaultPath="defaultCover" :size="160"></single-crop>
              <div class="c-name">
                <v-text-field
                  data-vv-name="group_name"
                  data-vv-validate-on="blur"
                  ref="groupName"
                  :label="$T('attributes.group_name')"
                  v-model="groupName"
                  color="clr-primary"
                  :counter="50"
                  v-validate="'required|max:50'"
                  :error-messages="getMessage('group_name')"
                  required
                  :disabled="inputDisabled || loading"
                ></v-text-field>
              </div>
            </div>
          </v-flex>
          <v-flex v-if="errMsg" class="c-errmsg">
            {{ errMsg }}
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="gid"
          color="clr-btn"
          outline
          @click.native="edit"
          :disabled="!editable || !members || members.length == 0"
          :loading="loading"
          >{{ $T('button.modify') }}</v-btn
        >
        <v-btn v-else color="clr-btn" outline @click.native="save" :disabled="!savable" :loading="loading">{{
          $T('button.new')
        }}</v-btn>
        <v-btn color="clr-btn-cancel" flat @click.native="closeDialog" :disabled="loading">{{ $T('button.close') }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createGroup, editGroup, getGroupDetail } from '../../api/group';

export default {
  data() {
    return {
      cid: 0,
      group: null,
      activeTime: null,
      coverDefault: true,
      coverUpdated: null,
      groupName: null,
      groupNameAutoFilled: false,
      groupNameDirty: false,
      cms: [],
      members: [],
      editors: [],
      open: false,
      loading: false,
      apiErrors: {},
      errMsg: null,
      inputDisabled: false,
    };
  },
  mounted() {
    this.onChangeCid(this.cid);
  },
  watch: {
    cid(n, o) {
      this.onChangeCid(n);
    },
    groupName(newValue, oldValue) {
      if (this.groupNameAutoFilled) {
        this.groupNameAutoFilled = false;
        return;
      }
      this.groupNameDirty = !!newValue;
    },
    members(newValue, oldValue) {
      if (!this.groupNameDirty && newValue && newValue.length > 0) {
        var name = '';
        for (var i = 0; i < newValue.length; i++) {
          if (name.length != 0) {
            name += ' / ';
          }
          name += this.getCmName(newValue[i]);
          if (name.length > 47) {
            name = name.substring(0, 47) + '...';
            break;
          }
        }
        this.groupNameAutoFilled = true;
        this.groupName = name;
        this.fields.group_name.invalid = false;
      }
    },
    open(n, o) {
      if (n) this.errMsg = null;
    },
  },
  computed: {
    isEdit() {
      return !!this.group;
    },
    gid() {
      return this.group ? this.group.id : 0;
    },
    isCreator() {
      return this.group && this.group.creator_cmid == this.cidToCmid(this.group.community_id);
    },
    defaultCover() {
      if (this.gid) return `/cover/g/${this.gid}/${this.activeTime}`;
      return this.cid ? `/cover/c/${this.cid}` : '/imgs/covers/community/sky.jpg';
    },
    editorRequired() {
      var c = this.getCommunity(this.cid);
      return c && !c.pm && (c.role == 1 || c.role == 2);
    },
    isFormInValid() {
      return Object.keys(this.fields).some(key => this.fields[key].invalid);
    },
    savable() {
      return !this.errMsg && !this.isFormInValid && !this.loading;
    },
    editable() {
      return !this.errMsg && !this.isFormInValid && !this.loading;
    },
  },
  methods: {
    getCmName(key) {
      var item = this.$refs.members.getItem(key);
      return item ? item.name : '';
    },
    filterAdmins(members) {
      return members.filter(item => {
        return item.role == 1 || item.role == 2;
      });
    },
    onConfirmOk(key, value) {
      this.postData();
      return;
    },
    onConfirmCancel(key, value) {
      this.loading = false;
    },
    save() {
      var communityId = this.cid;

      this.loading = true;
      var self = this;
      this.$validator.validateAll().then(result => {
        self.$refs.cid.validate(result => {
          if (!result) {
            console.warn('cid is invalid.');
            return;
          }
          self.$refs.members.validate(result => {
            if (!result) {
              console.warn('members is invalid.');
              return;
            }
            if (self.editorRequired) {
              self.$refs.editors.validate(result => {
                if (!result) {
                  console.warn('editors is invalid.');
                  return;
                }
                self.errMsg = null;
                self.postData();
              });
            } else {
              self.postData();
            }
          });
        });
      });
    },
    edit() {
      var communityId = this.cid;
      this.loading = true;
      var self = this;
      this.$validator.validateAll().then(result => {
        self.$refs.members.validate(result => {
          if (!result) {
            console.warn('members is invalid.');
            return;
          }
          if (self.editorRequired) {
            self.$refs.editors.validate(result => {
              if (!result) {
                console.warn('editors is invalid.');
                return;
              }
              self.postData();
            });
          } else {
            self.postData();
          }
        });
      });
    },
    postData() {
      var data = new FormData();
      data.append('cid', this.cid);
      data.append('name', this.groupName);
      data.append('members', this.members);
      data.append('editors', this.editors);
      data.append('change_cover', !!this.coverUpdated);
      if (this.coverUpdated) {
        data.append('cover', this.coverUpdated, 'newCover');
      }

      var self = this;
      if (this.gid) {
        data.append('gid', this.gid);
        editGroup(data)
          .then(function(response) {
            self.$emit('changed', response);
            self.loading = false;
            self.closeDialog();
          })
          .catch(function(error) {
            console.log(error);
            self.errMsg = $T('common.failed.edit');
            self.loading = false;
          });
      } else {
        createGroup(data)
          .then(function(response) {
            self.$emit('changed', response);
            self.loading = false;
            self.closeDialog();
          })
          .catch(function(error) {
            console.log(error);
            self.errMsg = $T('common.failed.register');
            self.loading = false;
          });
      }
    },
    initDialog() {
      this.group = null;
      this.coverDefault = true;
      this.coverUpdated = null;
      this.groupName = null;
      this.groupNameDirty = false;
      this.fields.group_name.invalid = true;
      this.members = [];
      this.editors = [];
      this.apiErrors = {};
    },
    onChangeCid(cid) {
      this.errMsg = null;
      this.inputDisabled = false;
      if (!this.gid && !this.groupNameDirty) {
        this.groupName = null;
      }
      if (!cid || cid == this.$store.state.community.fcid) return;
      // var c = this.getCommunity(cid);
      // if (this.isEdit && !c.pm && c.role != 1 && c.role != 2) {
      //   this.errMsg = $T('page.member.info.group.create.no-auth');
      //   this.inputDisabled = true;
      //   return;
      // }
    },
    openCreateDialog(communityId) {
      if (this.getRouteCid()) this.cid = this.getRouteCid();
      this.initDialog();
      this.open = true;
      setTimeout(this.initFocus, 500);
    },
    openEditDialog(group) {
      this.cid = 0;
      this.initDialog();
      this.group = group;
      this.loading = true;
      var self = this;
      getGroupDetail(this.gid)
        .then(function(response) {
          var g = response.group;
          self.group = g;
          self.activeTime = g.active_time;
          self.cid = g.community_id;
          self.groupName = g.name;
          self.groupNameDirty = true;
          self.fields.group_name.invalid = false;
          self.coverDefault = !g.original_cover;
          self.members = response.members;
          self.editors = response.editors;
          self.loading = false;
          self.open = true;
          setTimeout(self.initFocus, 500);
        })
        .catch(function(e) {
          console.error('failed to get data', e);
          self.errGetData();
          self.loading = false;
        });
    },
    initFocus() {
      this.$nextTick(function() {
        if (this.gid || this.cid) {
          this.$refs.members.focus();
        } else if (!this.$refs.cid) {
          this.$refs.groupName.focus();
        } else {
          this.$refs.cid.focus();
        }
      });
    },
    closeDialog() {
      this.open = false;
    },
    getMessage(fieldName) {
      return this.apiErrors[fieldName] && this.apiErrors[fieldName][this.inputValue]
        ? this.apiErrors[fieldName][this.inputValue]
        : this.errors.collect(fieldName);
    },
  },
};
</script>

<style scoped>
.container {
  padding: 16px 24px 20px 24px;
}
.le-tbs .container {
  padding: 16px 24px 20px 24px;
}
.c-name {
  flex-grow: 1;
}
.c-flex-container {
  display: flex;
  width: 250px;
}
.c-flex-container .l {
  width: 150px;
}
.c-flex-container .r {
  width: 90px;
  padding-left: 10px;
}
.c-errmsg {
  font-size: 14px;
  text-align: left;
  padding-top: 0px !important;
}
.le-tbs .c-select-community {
  width: 100%;
  padding: 0;
}

.le-tbs .c-community {
  position: absolute;
  top: 42px;
  left: 0px;
  width: 100%;
  padding: 0 24px;
}

.le-tbs .c-cover-area {
  flex-direction: column !important;
}
.le-tbs .c-img-item {
  left: 50%;
  transform: translateX(-50%);
  margin-top: -8px;
  margin-bottom: 8px;
}
.c-editor {
  padding-top: 0;
  padding-bottom: 16px;
}
.le-tbs .c-editor {
  margin-top: -8px;
}
.le-tbs .c-com-chip {
  margin-top: 24px;
}
.c-icon-area {
  position: relative;
  height: 10px;
}
</style>
